import { z, ZodString } from "zod";
import { errorMessage } from "../helper/errorMessage";

export const emailValidator: ZodString = z
  .string()
  .min(1, { message: errorMessage("required-field", { field: "email" }) })
  .email(errorMessage("invalid-email-address"));
